import React from "react";
import styled from "styled-components";
import { read_timeline_note_label } from "../../utils/timeline/timeline_formatting";

const TimelineSystem = styled.div`
    p {
        color: ${p => p.theme.color};
        overflow-wrap: anywhere;
        white-space: pre-wrap;
    }
`;

// Displays sync warnings and unknown historical fallback events.
export const Timeline_System = (props) => {
    return (
        <TimelineSystem>
            <p>{read_timeline_note_label(props.event)}</p>
        </TimelineSystem>
    );
};
